export default "__VITE_ASSET__CN1dJC8w__"